export default "__VITE_ASSET__mtw8RYhwisOW80CW$Oci$w__"